import { InjectionToken } from '@angular/core';
import { AnalyticsPageName, PageMappingData } from '@kanalytics';

export const PAGE_MAPPING = new InjectionToken<PageMappingData>('PageMapping');

export const PAGE_MAPPING_DATA: PageMappingData = {
  pages: [
    { pageName: AnalyticsPageName.accountDeletion, regex: /^\/deletion$/ },
    { pageName: AnalyticsPageName.accountDeletionConfirmation, regex: /^\/deletion-confirmation$/ },
    { pageName: AnalyticsPageName.challengeDetail, regex: /^\/challenges\/.*/, params: ['challengeId'] },
    { pageName: AnalyticsPageName.challenges, regex: /^\/challenges.*/ },
    { pageName: AnalyticsPageName.changeEmail, regex: /^\/settings\/change-email$/ },
    { pageName: AnalyticsPageName.changeNickname, regex: /^\/settings\/change-nickname.*/ },
    { pageName: AnalyticsPageName.confirmEmail, regex: /^\/welcome\/signup\/verification\/email.*/ },
    { pageName: AnalyticsPageName.confirmEmailResendCode, regex: /^\/welcome\/signup\/verification\/no-code.*/ },
    { pageName: AnalyticsPageName.confirmNewEmail, regex: /^\/settings\/change-email\/verification.*/ },
    {
      pageName: AnalyticsPageName.confirmNewEmailResendCode,
      regex: /^\/settings\/change-email\/verification\/no-code.*/,
    },
    { pageName: AnalyticsPageName.compare, regex: /^\/me\/life\/compare.*/, info: { type: 'life' } },
    { pageName: AnalyticsPageName.compare, regex: /^\/me\/work\/compare.*/, info: { type: 'work' } },
    { pageName: AnalyticsPageName.dialogue, regex: /^\/dialogue(\?|$).*/ },
    { pageName: AnalyticsPageName.discover, regex: /^\/discover.*/ },
    { pageName: AnalyticsPageName.eligibility, regex: /^\/welcome\/eligibility\/email.*/, info: { type: 'email' } },
    {
      pageName: AnalyticsPageName.eligibility,
      regex: /^\/welcome\/eligibility\/postal_dob_name.*/,
      info: { type: 'postal_dob_name' },
    },
    { pageName: AnalyticsPageName.eligibility, regex: /^\/welcome\/eligibility.*/ },
    { pageName: AnalyticsPageName.eula, regex: /^\/eula.*/ },
    { pageName: AnalyticsPageName.feedback, regex: /^\/feedback.*/ },
    { pageName: AnalyticsPageName.help, regex: /^\/help.*/ },
    { pageName: AnalyticsPageName.invite, regex: /^\/invite.*/ },
    { pageName: AnalyticsPageName.landing, regex: /^\/welcome$/ },
    { pageName: AnalyticsPageName.legalDocAcceptance, regex: /^\/privacy-full*/ },
    { pageName: AnalyticsPageName.login, regex: /^\/login.*/ },
    { pageName: AnalyticsPageName.meView, regex: /^\/me$/ },
    { pageName: AnalyticsPageName.meEdit, regex: /^\/me\/edit.*/ },
    { pageName: AnalyticsPageName.mobileAppInfo, regex: /^\/mobile_app_info.*/ },
    { pageName: AnalyticsPageName.mobileAppInterstitial, regex: /^\/welcome\/mobile-app\/interstitial.*/ },
    { pageName: AnalyticsPageName.myPhotos, regex: /^\/me\/photos.*/ },
    { pageName: AnalyticsPageName.privacyPledge, regex: /^\/welcome\/notice.*/ },
    { pageName: AnalyticsPageName.purposefulDays, regex: /^\/purposeful-days.*/ },
    { pageName: AnalyticsPageName.ready, regex: /^\/welcome\/ready.*/ },
    { pageName: AnalyticsPageName.setPassword, regex: /^\/welcome\/signup\/password.*/ },
    { pageName: AnalyticsPageName.settings, regex: /^\/settings$/ },
    {
      pageName: AnalyticsPageName.signup,
      regex: /^\/welcome\/signup(?!\/(email|verification\/email|verification\/no-code)).*/,
    },
    { pageName: AnalyticsPageName.signupEmail, regex: /^\/welcome\/signup\/email.*/ },
    { pageName: AnalyticsPageName.onboarding, regex: /^\/welcome\/error.*/ },
    { pageName: AnalyticsPageName.onboarding, regex: /^\/welcome(?!\/privacy).*/ },
    { pageName: AnalyticsPageName.onboardingDialogue, regex: /^\/dialogue\/onboarding.*/ },
    { pageName: AnalyticsPageName.onboardingLegalDocAcceptance, regex: /^\/welcome\/privacy.*/ },
    { pageName: AnalyticsPageName.privacy, regex: /^\/privacy.*/ },
    { pageName: AnalyticsPageName.progress, regex: /^\/progress.*/ },
    { pageName: AnalyticsPageName.pulseSurveyIntroScreen, regex: /^\/pulse_survey.*/ },
    { pageName: AnalyticsPageName.questionSet, regex: /^\/question_set.*/ },
    { pageName: AnalyticsPageName.quest, regex: /^\/quest.*/ },
    { pageName: AnalyticsPageName.reminders, regex: /^\/reminders.*/ },
    { pageName: AnalyticsPageName.report, regex: /^\/report.*/ },
    { pageName: AnalyticsPageName.resources, regex: /^\/resources.*/ },
    { pageName: AnalyticsPageName.saved, regex: /^\/cards\/saved.*/ },
    { pageName: AnalyticsPageName.takeAction, regex: /^\/cards\/take-action.*/ },
    { pageName: AnalyticsPageName.today, regex: /^\/today.*/ },
  ],
  dontTrack: ['/login/email', '/login/reset/code', '/login/reset/password', '/logout'],
  dontCache: ['/login'],
};
